<template>
    <div :class="['page-wrapper']">

        <v-main-header @toggleSidebar="$refs.sidebar.toggleSidebar()"></v-main-header>

        <!-- BEGIN CONTAINER -->
        <div class="page-container">

            <!-- BEGIN SIDEBAR -->
            <v-sidebar ref="sidebar"/>
            <!-- END SIDEBAR -->

            <!-- BEGIN CONTENT -->
            <div class="page-content-wrapper">
                <!-- BEGIN CONTENT BODY -->
                <div class="page-content grey">
                    <!-- BEGIN PAGE HEADER-->

                    <!-- BEGIN PAGE BAR -->
                    <v-pagebar/>
                    <!-- END PAGE BAR -->
                    <slot></slot>
                </div>
                <!-- END CONTENT BODY -->
            </div>
            <!-- END CONTENT -->

        </div>
        <!-- END CONTAINER -->

        <!-- BEGIN FOOTER -->
        <div class="page-footer">
            <div class="page-footer-inner">Tuango Admin</div>
            <vm-back-top :bottom="100" :duration="1000" :timing="'ease'">
                <div class="scroll-top">
                    <i class="icon-arrow-up"></i>
                </div>
            </vm-back-top>
        </div>
        <!-- END FOOTER -->
    </div>
</template>

<script>
  /* ============
   * Default Layout
   * ============
   *
   * Used for the home and account pages.
   *
   * Layouts are used to store a lot of shared code.
   * This way the app stays clean.
   */
  import VmBackTop from 'vue-multiple-back-top'
  import VSidebar from '../components/sidebar/Sidebar'
  import VPagebar from '../components/Pagebar'
  import VMainHeader from '../components/header/Header'

  export default {
    /**
     * The name of the layout.
     */
    name: 'default-layout',
    components: {
      VSidebar,
      VMainHeader,
      VPagebar,
      VmBackTop
    },
    /**
     * The data that can be used by the page.
     *
     * @returns {Object} The view-model data.
     */
    data: function () {
      return {
        // section: 'Dash',
        year: new Date().getFullYear(),
        desktopMq: 992
      }
    },
    /**
     * The methods that the layout can use.
     */
    methods: {
      /**
       * Will log the user out.
       */
      logout () {
        this.$store.dispatch('auth/logout')
      }
    }
  }
</script>

<style lang="scss" scoped>
    .page-content {
        &.grey {
            background: #eef1f5;
        }
    }

    .scroll-top {
        > i {
            display: inline-block;
            color: #687991;
            font-size: 30px;
            opacity: .6;
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/layouts/Default.vue